// Utility for displaying human-readable names of Market Items categories.
//
// The stored category names ARE the Planeta Nostra names (Knowledge, Barack
// Slots, Avatars, Crash Eggs), so nothing needs renaming here — the table is
// empty and every category displays as stored. It stays as a hook: the Vision
// Makers build of this editor used it to re-label the same categories
// (Knowledge → Data, Avatars → Agents, …), and a future rebrand would too.
export const marketCategoryDisplayNames = {};
export function getMarketCategoryDisplayName(category) {
    return marketCategoryDisplayNames[category] || category;
}
